module.exports = __webpack_public_path__ + "static/img/cover_tips_3.978f0957.png";